import {stage} from "../../../config/stage.ts";

// flexinet-console-api
const consoleApi = {
    prod: {
        endpoint: 'https://f3lssqzzmbd6vfegfduj5ebmye.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    test: {
        endpoint: 'https://x2tksew75nbnja3x7yuvmlv6pe.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    dev: {
        endpoint: 'https://bbaseq6utvbztehupw2byq3eme.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    ide: {
        endpoint: 'https://bbaseq6utvbztehupw2byq3eme.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
};

export const consoleApiConfig = consoleApi[stage];
